if (document.querySelectorAll('.new_custom_drawer_products').length > 0) {
    function FounderCookie(cookieName) {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(cookieName + '=')) {
          return true;
        }
      }
      return false;
    }

    function startTimer(duration, display) {
      var timer = duration,
        minutes,
        seconds;
      setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);
        // minutes = minutes < 10 ? "0" + minutes : minutes;
        // seconds = seconds < 10 ? "0" + seconds : seconds;

        var minutes_fst = minutes.toString().split('').map(Number)[0];
        var minutes_scd = minutes.toString().split('').map(Number)[1];

        var seconds_fst = seconds.toString().split('').map(Number)[0];
        var seconds_scd = seconds.toString().split('').map(Number)[1];

        if (typeof minutes_scd !== 'undefined') {
          display.querySelector('#timer-hours').innerHTML = `<span>${minutes_fst}</span><span>${minutes_scd}</span>`;
        } else {
          display.querySelector('#timer-hours').innerHTML = `<span>0</span><span>${minutes_fst}</span>`;
        }

        if (typeof seconds_scd !== 'undefined') {
          display.querySelector('#timer-minutes').innerHTML = `<span>${seconds_fst}</span><span>${seconds_scd}</span>`;
        } else {
          display.querySelector('#timer-minutes').innerHTML = `<span>0</span><span>${seconds_fst}</span>`;
        }

        if (FounderCookie('offerInvalid')) {
        } else {
          if (--timer < 0) {
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + 7);
            document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
          }
        }

        if (FounderCookie('offerInvalid')) {
          if (document.querySelector('.drawer_timer_outer-wrapp')) {
            document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
          }
          if (document.querySelector('.new_custom_drawer_products')) {
            document.querySelector('.new_custom_drawer_products').style.display = 'none';
          }
          window.localStorage.removeItem('seconds');
          window.localStorage.removeItem('minutes');
        } else {
          if (document.querySelector('.drawer_timer_outer-wrapp')) {
            document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
          }
          if (document.querySelector('.new_custom_drawer_products')) {
            document.querySelector('.new_custom_drawer_products').style.display = 'block';
          }
          window.localStorage.setItem('seconds', seconds);
          window.localStorage.setItem('minutes', minutes);
        }
      }, 1000);
    }

    window.onload = function () {
      sec = parseInt(window.localStorage.getItem('seconds'));
      min = parseInt(window.localStorage.getItem('minutes'));

      if (FounderCookie('offerInvalid')) {
        if (document.querySelector('.drawer_timer_outer-wrapp')) {
          document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
        }
        if (document.querySelector('.new_custom_drawer_products')) {
          document.querySelector('.new_custom_drawer_products').style.display = 'none';
        }
        window.localStorage.removeItem('seconds');
        window.localStorage.removeItem('minutes');
      } else {
        if (document.querySelector('.drawer_timer_outer-wrapp')) {
          document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
        }
        if (document.querySelector('.new_custom_drawer_products')) {
          document.querySelector('.new_custom_drawer_products').style.display = 'block';
        }
      }

      if (parseInt(min * sec)) {
        var fiveMinutes = parseInt(min * 60) + sec;
      } else {
        var fiveMinutes = 60 * 30;
      }

      display = document.querySelector('#timer-box');
      if (parseInt(min) == 0) {
        if (document.querySelector('.drawer_timer_outer-wrapp')) {
          document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
        }
        if (document.querySelector('.new_custom_drawer_products')) {
          document.querySelector('.new_custom_drawer_products').style.display = 'none';
        }
        window.localStorage.removeItem('seconds');
        window.localStorage.removeItem('minutes');
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 7);
        document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
      } else {
        startTimer(fiveMinutes, display);
      }
    };
  } else {
    document.querySelector('.drawer_timer_outer-wrapp').classList.add('hidden');
  }